import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      position: 'absolute',
      zIndex: 1000,

      width: '100%',
      padding: '1rem',

      textAlign: 'center',
    },
    select: {
      minHeight: '3.7rem',
      minWidth: '30rem',

      background: theme.palette.background.default,
      color: theme.palette.secondary.main,
      borderRadius: 5,

      '&.Mui-disabled': {
        color: theme.palette.secondary.main,
      },
    },
    selectMenu: {
      paddingLeft: '1rem',
    },
    menuList: {
      maxHeight: '28rem',

      '& .MuiMenuItem-root': {
        borderBottom: '1px solid transparent',
        borderImage:
          'linear-gradient(90deg, transparent 5%, #CECFCE 5%, #CECFCE 95%, transparent 95%)',
        borderImageSlice: 1,
      },
    },
    menuListItem: {
      width: '30rem',

      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1.5),

      fontSize: '1.4rem',
      // paddingBottom: '0.5rem',

      '& > span': {
        lineHeight: 0,
        fontWeight: 500,

        '&:nth-child(3)': {
          flex: 1,
          textAlign: 'center',
        },
      },
    },
  }),
)
